import { getPlainTextFromHtml } from '@ytl/common-web';
import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';

export const LoginHero = () => {
  const { translation } = useLanguage();
  const { initParams } = useOpenAm();

  return (
    <>
      <div className="login-page__hero">
        <div className="login-page__hero__content">
          {(!initParams || initParams?.realm === 'b2c') && (
            <>
              <h1>{translation.loginRegister.register.hero.header}</h1>
              <p
                aria-label={getPlainTextFromHtml(
                  translation.loginRegister.register.hero.desc(
                    initParams?.appLink,
                    initParams?.helpLink,
                    initParams?.regLink,
                  ),
                )}
                dangerouslySetInnerHTML={{
                  __html: translation.loginRegister.register.hero.desc(
                    initParams?.appLink,
                    initParams?.helpLink,
                    initParams?.regLink,
                  ),
                }}
              ></p>
            </>
          )}
          {initParams && initParams?.realm !== 'b2c' && <h1>{translation.loginRegister.register.hero.headerb2b}</h1>}
        </div>
      </div>
    </>
  );
};
